import { render, staticRenderFns } from "./retailers-item-list.vue?vue&type=template&id=2de4ca3a"
import script from "./retailers-item-list.vue?vue&type=script&lang=js"
export * from "./retailers-item-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports